import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { Guest, GuestService, NotificationDialogComponent } from 'app/shared';
import { ValidationService } from 'app/shared/services/validation.service';

@Component({
    selector: 'app-guest-form',
    templateUrl: './guest-form.component.html',
    styleUrls: ['./guest-form.component.scss'],
    standalone: false
})
export class GuestFormComponent implements OnInit {
  canEdit: boolean = false;
  @Input() guest: Guest;
  @Input() canEditUserInfo: boolean = true;
  @Input() canUpdate: boolean = false;
  @Input() isNewAccount: boolean;
  @Output() changeEditUserInfoButton = new EventEmitter();
  guestInfoLoading: boolean;

  constructor(
    private validationService: ValidationService,
    private guestService: GuestService,
    private dialog: MatDialog,
    ) { }

  ngOnInit() {
    this.guestInfoLoading = false;
  }

  enableUserInfoEdit() {
    this.canEditUserInfo = !this.canEditUserInfo;
  }

  disableUserInfoEdit() {
    this.canEditUserInfo = !this.canEditUserInfo;
    this.changeEditUserInfoButton.emit(this.canEditUserInfo);
  }

  saveGuestInfo() {
    this.guestInfoLoading = true;
    let validEmail = this.validationService.validateEmail(this.guest.email);
    let validGuest = this.validationService.validateGuest(this.guest);

    if (validEmail && validGuest.isValid) {
      this.guestService.updateGuest(this.guest).subscribe({
        next: results => {
          this.guestInfoLoading = false;
          let content;
          if (results.reason) {
            content = `Changes in the user profile have been saved successfully with messages:\n${results.reason}`;
          } else {
            content = 'Changes in the user profile have been saved successfully';
          }
          this.openNotificationDialog('Updated successfully', content);
          this.canEditUserInfo = !this.canEditUserInfo;
        },
        error: e => {
          this.guestInfoLoading = false;
          this.openNotificationDialog('Problem updating', 'There was a problem updating the user profile');
          console.error(e);
        }
      });
    } else if (!validEmail) {
      this.openNotificationDialog('Error', 'Email is invalid');
      this.guestInfoLoading = false;
    } else {
      this.openNotificationDialog('Error', 'Invalid. Please fill all required fields and resubmit.');
      this.guestInfoLoading = false;
    }
  }

  openNotificationDialog(titleMessage: string, contentMessage: string) {
    const notificationDialog = this.dialog.open(NotificationDialogComponent, {
      data: {
        title: titleMessage,
        content: contentMessage,
      }
    });

    notificationDialog.afterClosed().subscribe(
      result => {
      }
    );
  }
}
